import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialSection() {
  return <section className="bg-neutral-950 text-white py-20 md:py-28 px-4" data-id="element-207">
      <div className="max-w-6xl mx-auto" data-id="element-208">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-16" data-id="element-209">
          What Other Men Are Saying
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-210">
          {/* Testimonial 1 */}
          <div className="bg-gray-900 border border-gray-800 p-8 rounded-2xl relative" data-id="element-211">
            <QuoteIcon className="absolute top-6 right-6 w-10 h-10 text-gray-800" data-id="element-212" />
            <div className="flex gap-1 mb-6" data-id="element-213">
              <StarIcon className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-214" />
              <StarIcon className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-215" />
              <StarIcon className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-216" />
              <StarIcon className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-217" />
              <StarIcon className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-218" />
            </div>
            <p className="text-gray-300 text-lg italic mb-8 relative z-10" data-id="element-219">
              "I'm 52 and a CEO. I thought the brain fog was just my life now.
              After 10 days on the Dopamine Manual and the Vitality Code, I feel
              like I'm 30 again. Best six dollars I've ever spent."
            </p>
            <div data-id="element-220">
              <p className="font-bold text-white text-lg" data-id="element-221">Marc T.</p>
              <p className="text-amber-500 text-sm" data-id="element-222">Tech Executive, 52</p>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-gray-900 border border-gray-800 p-8 rounded-2xl relative" data-id="element-223">
            <QuoteIcon className="absolute top-6 right-6 w-10 h-10 text-gray-800" data-id="element-224" />
            <div className="flex gap-1 mb-6" data-id="element-225">
              <StarIcon className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-226" />
              <StarIcon className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-227" />
              <StarIcon className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-228" />
              <StarIcon className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-229" />
              <StarIcon className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-230" />
            </div>
            <p className="text-gray-300 text-lg italic mb-8 relative z-10" data-id="element-231">
              "I was skeptical, but the 15-minute daily protocol fits perfectly
              into my packed schedule. My energy is through the roof and the
              stubborn belly fat is finally starting to melt off."
            </p>
            <div data-id="element-232">
              <p className="font-bold text-white text-lg" data-id="element-233">David R.</p>
              <p className="text-amber-500 text-sm" data-id="element-234">Business Owner, 47</p>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-gray-900 border border-gray-800 p-8 rounded-2xl relative" data-id="element-235">
            <QuoteIcon className="absolute top-6 right-6 w-10 h-10 text-gray-800" data-id="element-236" />
            <div className="flex gap-1 mb-6" data-id="element-237">
              <StarIcon className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-238" />
              <StarIcon className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-239" />
              <StarIcon className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-240" />
              <StarIcon className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-241" />
              <StarIcon className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-242" />
            </div>
            <p className="text-gray-300 text-lg italic mb-8 relative z-10" data-id="element-243">
              "The brain fog is gone. I'm sharper in the courtroom and actually
              have energy for my kids when I get home instead of crashing on the
              couch. Incredible value."
            </p>
            <div data-id="element-244">
              <p className="font-bold text-white text-lg" data-id="element-245">James L.</p>
              <p className="text-amber-500 text-sm" data-id="element-246">Attorney, 55</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}